import { defaultServer } from '~/api/def/servers/defaultServer';
import { getExecEndpoint } from '../../service/getExecEndpoint';
import { BqResponse } from './types';

export const valuationEndpoint = {
  server: defaultServer,
  path: 'valuation',
  description: 'Valuation operations',
};

const endpointValuationExec = getExecEndpoint<{
  endpoint: typeof valuationEndpoint;
  methods: {
    POST: {
      response: BqResponse<object>;
    };
  };
}>(valuationEndpoint);

export const endpointPcValuationRecalculatePOST = async (
  portfolioId: string,
) => {
  const response = await endpointValuationExec<'POST'>({
    method: 'POST',
    urlExtra: `/portfolio/${portfolioId}`,
  });
  if (!response) {
    throw new Error('Could not recalculate portfolio valuation');
  }

  if (response.success === 0) {
    throw new Error('Could not recalculate portfolio valuation');
  }

  return response;
};

export const endpointFundValuationRecalculatePOST = async (fundId: string) => {
  const response = await endpointValuationExec<'POST'>({
    method: 'POST',
    urlExtra: `/fund/${fundId}`,
  });
  if (!response) {
    throw new Error('Could not recalculate fund valuation');
  }

  if (response.success === 0) {
    throw new Error('Could not recalculate fund valuation');
  }

  return response;
};
